import React from 'react'
import "../styles/Features.css"
import { FeatureOne } from './FeatureOne'

export const Features = () => {
  return (
    <div className='features'>
      <FeatureOne />
    </div>
  )
}
